<template>
    <v-layout column fill-height>
        <v-card class="uv-flex-fill-remaining">
            <v-window v-model="step" vertical class="flex-grow-1" style="overflow-y:auto;height:100%">
                <v-window-item >
                    <v-card flat :loading="brands.loading">
                        <v-card-title>{{$t('placeholders.chooseBrand')}}</v-card-title>
                        <v-row dense>
                            <v-col cols="2"
                            v-for="brand in brands.items"
                            :key="brand.id" class="d-flex align-center justify-center">
                                <v-sheet 
                                rounded 
                                class="pa-3 d-flex flex-column align-center" 
                                style="cursor:pointer">
                                    <v-img
                                    :src="brand.logo ?? sp_logo"
                                    max-height="80px"
                                    contain
                                    @click="selectBrand(brand)"
                                    width="100px"
                                    aspect-ratio="1"
                                    class="brand-logo">                    
                                    </v-img>
                                    <div class="d-flex align-center justify-center">
                                        <span>{{$t(brand.name)}}</span>
                                    </div>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-window-item>
                <v-window-item>
                    <v-fade-transition mode="out-in">
                        <router-view/>
                    </v-fade-transition>
                </v-window-item>
            </v-window>
        </v-card>
    </v-layout>
</template>

<script>
import sp_logo from "/public/sp_logo_no_text.svg"
import {mapMutations} from "vuex"
export default {
    name: "CampaignsHome",
    beforeRouteUpdate(to, from, next){
        if (to.name === 'CampaignsHome') {
            this.step = 0
            this.SET_pageAdditionalInfo([])
        }
        next()
    },
    destroyed(){
        this.SET_pageAdditionalInfo([])
    },
    created(){
        // this.getCampaigns()
        this.getBrands()
    },
    data(){
        return {
            sp_logo,
            brands: {
                items: [],
                loading: false,
            },
            step: 0,
        }
    },
    computed: {
        brandId(){
            return parseInt(this.$route.params.brandId)
        }
    },
    methods:{
        ...mapMutations(["SET_pageAdditionalInfo"]),
        getBrands() {
            if (this.brands.items.length) {
                return
            }
            this.brands.loading = true;
            this.$apiHttp({
                url: "/vehicles/brands",
            }, {})
                .then((res) => {
                    this.brands.items = res.data.data
                })
                .finally(() => {
                    this.brands.loading = false;
                    let brand = null;
                    if (this.brandId){
                        brand = this.brands.items.find((brand) => brand.id == this.brandId)
                    }else if (this.brands.items.length == 1){
                        brand = this.brands.items[0]
                    }
                    if (brand){
                        this.selectBrand(brand)
                    }
                });
        },
        selectBrand(brand){
            this.step = 1
            this.SET_pageAdditionalInfo([{title: brand.display_name}]) 
            this.$router.push({name: 'CampaignsList', params: {brandId: brand.id}})
        }
    },
}
</script>

<style lang="scss" scoped>
:deep(.v-window__container){
    height: 100%;
    min-height: 0%;
    max-height: 100%;
}

:deep(.v-window-item){
    height: 100%;
}

</style>